var Broadcast = window.Broadcast = (function () {
    function init() {
        $(document).on('click', '[broadcast-button]', function(this: JQuery) {
            const data = $(this).attr('t-data');

            if (data) {
                const parsedData: { [key: string]: any } = JSON.parse(data); // fix any
                parsedData.button = $(this);

                document.dispatchEvent(new CustomEvent<any>('openBroadcast', {
                    detail: parsedData
                }));
            }
        });
    }

    return {
        init
    }
}())

$(() => {
    Broadcast.init();
});
